/******************************************************
 * CareerLearning — Registrant Assignment (POST-PURCHASE)
 * v2 FRESH DESIGN reskin.
 *
 * SAME LOGIC AS PRODUCTION:
 *   - Runs on /pages/registration only
 *   - Order-based, localStorage drafts, partial completion
 *   - Webhook fires only on exit points (Complete / Save & Exit /
 *     return to review / Confirm All) — concurrency-safe
 *   - Lookup /apps/registration · submit /apps/registration-submit
 *
 * ONLY CHANGE: every screen now renders with the fresh CL classes
 * from cl-registration.css (no inline styles). Load that stylesheet
 * on /pages/registration. Container stays #registration-container.
 ******************************************************/

(function () {
  const STORAGE_KEY = "cl_registration_draft";
  const ORDER_STORAGE_KEY = "cl_registration_order";

const LOOKUP_URL = "https://clownantics.app.n8n.cloud/webhook/shopify-registration-lookup";
const SAVE_URL   = "https://clownantics.app.n8n.cloud/webhook/shopify-registrant-submit";

  const CL_REG_CSS = `#cl-registration-page {
    --cl-primary:#123A6F; --cl-blue:#1F60AE; --cl-accent:#1F60AE; --cl-gold:#FBB834;
    --cl-cta:#1E3A5F; --cl-cta-hover:#162D4A; --cl-text:#333; --cl-muted:#64748B;
    --cl-soft:#F3F7FF; --cl-divider:#E0E0E0;
    --cl-r-sm:8px; --cl-r-md:12px; --cl-r-lg:18px;
    --cl-shadow-sm:0 1px 2px rgba(18,58,111,.06), 0 4px 12px rgba(18,58,111,.05);
    --cl-shadow-md:0 2px 4px rgba(18,58,111,.05), 0 12px 30px rgba(18,58,111,.10);
    --cl-shadow-lg:0 12px 30px rgba(18,58,111,.16), 0 30px 60px rgba(18,58,111,.12);
    --cl-font:'Raleway',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
    font-family:var(--cl-font); color:var(--cl-text);
    background:
      radial-gradient(ellipse 70% 60% at 100% 0%, rgba(51,176,240,0.10), transparent 60%),
      radial-gradient(ellipse 60% 50% at 0% 30%, rgba(251,184,52,0.07), transparent 55%),
      linear-gradient(180deg, #F3F7FF 0%, #FFFFFF 55%);
    min-height:100vh;
  }
  .reg-shell{max-width:940px; margin:0 auto; padding:56px 24px 90px;}
  .reg-intro{margin-bottom:32px;}
  .reg-eyebrow{display:inline-flex; align-items:center; gap:7px; white-space:nowrap; font-size:12px; font-weight:700; letter-spacing:.12em; text-transform:uppercase; color:var(--cl-blue); background:#fff; border:1px solid var(--cl-divider); padding:7px 14px; border-radius:999px; box-shadow:var(--cl-shadow-sm);}
  .reg-eyebrow svg{width:14px; height:14px; color:var(--reg-accent,var(--cl-gold));}
  .reg-intro h1{font-size:clamp(40px,5.6vw,56px); font-weight:700; color:var(--cl-primary); letter-spacing:-.025em; line-height:1.04; margin:18px 0 12px;}
  .reg-intro .sub{font-size:18px; color:var(--cl-muted); margin:0; max-width:60ch; line-height:1.55;}
  .reg-intro .order-tag{display:inline-flex; align-items:center; gap:7px; white-space:nowrap; margin-top:16px; font-size:14px; color:var(--cl-text); font-weight:600;}
  .reg-intro .order-tag b{color:var(--cl-primary);}

  .prog-wrap{display:flex; align-items:left; gap:18px; margin-top:26px; background:#fff; border:1px solid var(--cl-divider); border-radius:var(--cl-r-lg); padding:18px 22px; box-shadow:var(--cl-shadow-sm);}
  .prog-ring{--p:0; position:relative; width:58px; height:58px; flex:none; border-radius:50%; background:conic-gradient(var(--reg-accent,var(--cl-gold)) calc(var(--p)*1%), #EAF0F8 0); display:grid; place-items:center; transition:background .45s ease;}
  .prog-ring::after{content:""; position:absolute; width:44px; height:44px; background:#fff; border-radius:50%;}
  .prog-ring .pf{position:relative; z-index:1; font-size:13px; font-weight:800; color:var(--cl-primary);}
  .prog-text .pt-lead{font-weight:700; color:var(--cl-primary); font-size:16px;}
  .prog-text .pt-sub{font-size:13.5px; color:var(--cl-muted); margin-top:2px;}

  .panel{background:#fff; border-radius:var(--cl-r-lg); box-shadow:var(--cl-shadow-sm); padding:28px 30px; margin-top:24px;}
  .panel-label{font-size:12px; font-weight:700; letter-spacing:.1em; text-transform:uppercase; color:var(--cl-muted); margin:0 0 18px;}

  .course-row{display:flex; align-items:flex-start; gap:16px; padding:18px 0; border-bottom:1px solid var(--cl-divider);}
  .course-row.last{border-bottom:none; padding-bottom:0;}
  .course-row-main{flex:1; min-width:0;}
  .course-row h3{margin:0 0 4px; font-size:17px; font-weight:700; color:var(--cl-primary); line-height:1.3;}
  .course-access{margin:0; font-size:14px; color:var(--cl-muted);}
  .course-count{flex:none; font-size:13px; font-weight:700; color:var(--cl-muted); display:inline-flex; align-items:left; gap:5px; white-space:nowrap; padding-top:2px;}
  .course-count.done{color:#2E7D5F;}
  .course-count svg{width:14px; height:14px;}
  .course-card:hover{box-shadow:var(--cl-shadow-md);}
  .course-media{flex:none; width:96px; position:relative; background:linear-gradient(135deg,#1F60AE 0%,#1F60AE 55%,#123A6F 100%); display:grid; place-items:center; overflow:hidden;}
  .course-card.done .course-media{background:linear-gradient(135deg,#48B07F 0%,#2E7D5F 55%,#1C5E45 100%);}
  .course-media::after{content:""; position:absolute; right:-40px; bottom:-50px; width:150px; height:150px; border-radius:50%; background:radial-gradient(circle at 30% 30%, rgba(255,255,255,.18), transparent 70%);}
  .course-media .cimg{position:absolute; inset:0; width:100%; height:100%; object-fit:cover;}
  .course-media svg{width:34px; height:34px; color:#fff; opacity:.95;}
  .course-content{flex:1; min-width:0; padding:22px 24px; display:flex; flex-direction:column;}
  .course-content .ctopic{font-size:11px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color:var(--reg-accent,var(--cl-gold));}
  .course-content h3{margin:6px 0 14px; font-size:21px; font-weight:700; color:var(--cl-primary); line-height:1.22;}
  .cmeta-pills{display:flex; flex-wrap:wrap; gap:9px;}
  .cmeta-pill{display:inline-flex; align-items:center; gap:7px; background:var(--cl-soft); border:1px solid rgba(31,96,174,.1); padding:8px 13px; border-radius:999px; font-size:13px; font-weight:600; color:var(--cl-text);}
  .cmeta-pill svg{width:14px; height:14px; color:var(--reg-accent,var(--cl-gold)); flex:none;}
  .course-foot{display:flex; align-items:center; gap:10px; margin-top:auto; padding-top:16px;}
  .course-foot .statuschip{display:inline-flex; align-items:center; gap:7px; font-size:13px; font-weight:700; padding:9px 15px; border-radius:999px;}
  .course-foot .statuschip svg{width:15px; height:15px; flex:none;}
  .course-card.partial .statuschip{background:rgba(31,96,174,.1); color:var(--cl-blue);}
  .course-card.done .statuschip{background:rgba(46,125,95,.14); color:#2E7D5F;}
  @media (max-width:600px){ .course-card{flex-direction:column;} .course-media{width:100%; height:84px;} }

  .reg-list{display:flex; flex-direction:column; gap:12px;}
  .reg-card{display:flex; align-items:center; gap:14px; padding:15px 18px; border-radius:var(--cl-r-md); border:1px solid var(--cl-divider); background:#fff; transition:all .15s;}
  .reg-card:hover{border-color:rgba(51,176,240,.5); box-shadow:var(--cl-shadow-sm);}
  .reg-card.open-seat-row{border-style:dashed; background:var(--cl-soft);}
  .reg-card .avatar{flex:none; width:44px; height:44px; border-radius:50%; background:var(--reg-accent,var(--cl-gold)); color:var(--cl-primary); display:grid; place-items:center; font-weight:800; font-size:15px;}
  .reg-card .avatar.empty{background:#DCE6F2; color:#94A8C4;}
  .reg-card .info{flex:1; min-width:0;}
  .reg-card .info .nm{font-weight:700; font-size:15px; color:var(--cl-primary); display:flex; align-items:center; gap:8px;}
  .reg-card .info .nm.muted{color:var(--cl-muted);}
  .reg-card .info .nm .tick{width:18px; height:18px; border-radius:50%; background:#2E7D5F; color:#fff; display:grid; place-items:center; flex:none;}
  .reg-card .info .nm .tick svg{width:11px; height:11px;}
  .reg-card .info .em{font-size:13px; color:var(--cl-muted);}
  .reg-card .edit{flex:none; background:var(--cl-soft); border:none; color:var(--cl-blue); font-weight:700; font-size:13px; padding:8px 14px; border-radius:999px; cursor:pointer; transition:all .15s; font-family:inherit;}
  .reg-card .edit:hover{background:var(--cl-primary); color:#fff;}

  .reg-continue{margin-top:26px;}
  .btn-continue{width:100%; background:var(--cl-cta); color:#fff; border:1.5px solid var(--cl-cta); border-radius:var(--cl-r-md); padding:18px; font-weight:700; font-size:16px; display:flex; align-items:center; justify-content:center; gap:10px; transition:all .15s; font-family:inherit; box-shadow:var(--cl-shadow-md); cursor:pointer;}
  .btn-continue:hover{background:var(--cl-cta-hover); transform:translateY(-1px); box-shadow:var(--cl-shadow-lg);}
  .btn-continue.done{background:#2E7D5F; border-color:#2E7D5F;}
  .btn-continue svg{width:18px; height:18px;}
  .reg-hint{text-align:center; font-size:13px; color:var(--cl-muted); margin:14px 0 0;}
  .reg-hint b{color:var(--reg-accent,var(--cl-gold));}
  .reg-foot{text-align:center; margin-top:26px; font-size:13px; color:var(--cl-muted);}
  .reg-foot a{color:var(--cl-accent); text-decoration:none; font-weight:600;}
  .seat-list{display:flex; flex-direction:column;}
  .seat-form{padding:22px 0; border-top:1px solid var(--cl-divider);}
  .seat-form:first-child{padding-top:4px; border-top:none;}
  .seat-head{display:flex; align-items:baseline; gap:12px; margin-bottom:14px;}
  .seat-num{font-size:13px; font-weight:800; letter-spacing:.04em; color:var(--cl-primary); white-space:nowrap;}
  .seat-course{font-size:12.5px; color:var(--cl-muted);}
  .seat-error{color:#dc2626; font-size:13px; margin:8px 0 0; display:none;}
  .btn-saveexit{display:block; width:100%; margin-top:12px; background:none; border:none; color:var(--cl-muted); font-family:inherit; font-weight:700; font-size:14px; padding:10px; cursor:pointer; text-decoration:underline;}
  .btn-saveexit:hover{color:var(--cl-primary);}
  .entry{max-width:560px; margin-top:8px;}
  .entry .field{margin-bottom:18px;}
  .entry-actions{display:flex; gap:10px; margin-top:22px; flex-wrap:wrap;}
  .entry-actions button{flex:1; min-width:130px; padding:15px; border-radius:var(--cl-r-md); font-family:inherit; font-weight:700; font-size:15px; transition:all .15s; cursor:pointer;}
  .entry-actions .btn-primary-modal{flex:1.6 !important;}

  /* lookup + status screens */
  .reg-lookup{max-width:480px; margin:0 auto; background:#fff; border:1px solid var(--cl-divider); border-radius:var(--cl-r-lg); box-shadow:var(--cl-shadow-md); padding:30px 32px;}
  .reg-lookup h2{margin:0 0 6px; font-size:24px; font-weight:700; color:var(--cl-primary);}
  .reg-lookup p{margin:0 0 20px; color:var(--cl-muted); font-size:14.5px;}
  .reg-field{display:flex; flex-direction:column; gap:6px; margin-bottom:16px;}
  .reg-field label{font-size:12px; font-weight:700; color:var(--cl-primary);}
  .reg-field input{font-family:inherit; font-size:15px; padding:12px 14px; border:1.5px solid var(--cl-divider); border-radius:var(--cl-r-md); color:var(--cl-text);}
  .reg-field input:focus{outline:none; border-color:var(--cl-accent); box-shadow:0 0 0 3px rgba(51,176,240,.12);}
  .reg-status{max-width:560px; margin:0 auto; background:#fff; border:1px solid var(--cl-divider); border-radius:var(--cl-r-lg); box-shadow:var(--cl-shadow-md); padding:32px 34px; text-align:center;}
  .reg-status .badge-ic{width:64px; height:64px; border-radius:50%; margin:0 auto 16px; display:grid; place-items:center;}
  .reg-status .badge-ic.ok{background:rgba(46,125,95,.14); color:#2E7D5F;}
  .reg-status .badge-ic.err{background:#FCEEEC; color:#C0392B;}
  .reg-status .badge-ic svg{width:30px; height:30px;}
  .reg-status h2{margin:0 0 8px; color:var(--cl-primary); font-size:23px; font-weight:700;}
  .reg-status p{color:var(--cl-muted); font-size:14.5px; margin:0 auto 18px; max-width:42ch;}
  .reg-spinner{width:42px; height:42px; border:4px solid #E3EAF4; border-top-color:var(--cl-blue); border-radius:50%; animation:cl-spin .8s linear infinite; margin:50px auto;}
  @keyframes cl-spin{to{transform:rotate(360deg);}}

  /* modal */
  .modal-overlay{position:fixed; inset:0; background:rgba(18,42,68,.45); backdrop-filter:blur(3px); display:none; align-items:center; justify-content:center; z-index:9999; padding:20px;}
  .modal-overlay #cl-registration-page{background:none!important; min-height:0!important; padding:0!important; width:auto;}
  .modal-overlay.open{display:flex;}
  .modal{background:#fff; border-radius:var(--cl-r-lg); max-width:480px; width:100%; box-shadow:var(--cl-shadow-lg); overflow:hidden; max-height:92vh; overflow-y:auto;}
  .modal-head{padding:24px 28px 0;}
  .modal-step-row{display:flex; align-items:center; gap:10px; margin-bottom:12px;}
  .modal-dots{display:flex; gap:5px;}
  .modal-dots .d{width:8px; height:8px; border-radius:50%; background:#DCE6F2;}
  .modal-dots .d.active{background:var(--cl-gold); width:22px; border-radius:999px;}
  .modal-dots .d.filled{background:#2E7D5F;}
  .modal-step{font-size:12px; font-weight:800; letter-spacing:.07em; text-transform:uppercase; color:var(--cl-muted); white-space:nowrap;}
  .modal-head h2{margin:0; font-size:22px; font-weight:700; color:var(--cl-primary);}
  .enrolling{margin:16px 28px 0; padding:14px 16px; background:var(--cl-soft); border-radius:var(--cl-r-md); display:flex; gap:12px; align-items:center;}
  .enrolling .etext{min-width:0; display:flex; flex-direction:column; gap:2px;}
  .enrolling .ei{flex:none; width:38px; height:38px; border-radius:10px; background:linear-gradient(135deg,#1F60AE,#123A6F); color:#fff; display:grid; place-items:center;}
  .enrolling .ei svg{width:19px; height:19px;}
  .enrolling .lbl{font-size:10.5px; font-weight:800; letter-spacing:.08em; color:var(--cl-blue); margin:0;}
  .enrolling .ct{font-weight:700; color:var(--cl-primary); font-size:14.5px; line-height:1.25;}
  .enrolling .se{font-size:12.5px; color:var(--cl-muted);}
  .modal-fields{padding:20px 28px 4px;}
  .field{display:flex; flex-direction:column; gap:6px; margin-bottom:15px;}
  .field label{font-size:12px; font-weight:700; color:var(--cl-primary);}
  .field input{font-family:inherit; font-size:15px; padding:12px 14px; border:1.5px solid var(--cl-divider); border-radius:var(--cl-r-md); color:var(--cl-text); background:#fff;}
  .field input:focus{outline:none; border-color:var(--cl-accent); box-shadow:0 0 0 3px rgba(51,176,240,.12);}
  .field-2{display:grid; grid-template-columns:1fr 1fr; gap:12px;}
  @media (max-width:460px){ .field-2{grid-template-columns:1fr;} }
  .modal-error{color:#dc2626; font-size:13px; margin:0 28px; display:none;}
  .modal-actions{display:flex; gap:9px; padding:16px 28px 26px; flex-wrap:wrap;}
  .modal-actions button{flex:1; min-width:96px; padding:13px; border-radius:var(--cl-r-md); font-family:inherit; font-weight:700; font-size:14px; transition:all .15s; cursor:pointer;}
  .btn-ghost{background:#fff; color:var(--cl-text); border:1.5px solid var(--cl-divider);}
  .btn-ghost:hover{background:var(--cl-soft); color:var(--cl-primary); border-color:var(--cl-primary);}
  .btn-primary-modal{background:var(--cl-cta); color:#fff; border:1.5px solid var(--cl-cta); flex:1.5 !important;}
  .btn-primary-modal:hover{background:var(--cl-cta-hover);}
  .btn-primary{display:inline-flex; align-items:center; gap:7px; background:var(--cl-cta); color:#fff; border:1.5px solid var(--cl-cta); border-radius:var(--cl-r-md); padding:12px 22px; font-weight:700; font-size:14px; font-family:inherit; cursor:pointer;}
  .btn-primary:hover{background:var(--cl-cta-hover);}`;

  let registrants = [];
  let currentRegistrantIndex = 0;
  let totalQuantity = 0;
  let orderName = null;
  let orderEmail = null;
  let orderNumericId = null;
  let orderFinancialStatus = null;
  let seatMap = [];
  let lineItems = [];
  let submittedSeats = new Set();
  let autoLoadedFromCustomer = false;

  document.addEventListener("DOMContentLoaded", init);

  /* ---------------- helpers ---------------- */

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function initials(f, l) { return ((f && f[0] || "") + (l && l[0] || "")).toUpperCase(); }
  function container() { return document.getElementById("registration-container") || document.body; }

  // Self-contained: inject the design CSS once, and guarantee a mount node
  // so the template can be just {{ page.content }} + this script.
  function ensureStyles() {
    if (document.getElementById("cl-reg-styles")) return;
    var s = document.createElement("style");
    s.id = "cl-reg-styles";
    s.textContent = CL_REG_CSS;
    document.head.appendChild(s);
  }
  function ensureContainer() {
    if (document.getElementById("registration-container")) return;
    var host = document.querySelector("main") || document.body;
    var d = document.createElement("div");
    d.id = "registration-container";
    host.appendChild(d);
  }

  const ICON = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 12 10 18 20 6"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    book: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h11a4 4 0 0 1 4 4v12a3 3 0 0 0-3-3H4z"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/></svg>',
    seats: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="4"/><path d="M2 21a7 7 0 0 1 14 0"/><path d="M17 11a4 4 0 0 0 0-6"/></svg>',
    receipt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18"/></svg>'
  };

  function groupBySeat(list, getSeat) {
    const groups = {};
    list.forEach(function (r, i) {
      if (!r) return;
      const seat = getSeat(r, i);
      const key = seat.variant_title ? seat.product_title + "|||" + seat.variant_title : seat.product_title;
      if (!groups[key]) groups[key] = { title: seat.product_title, variant: seat.variant_title, registrants: [] };
      groups[key].registrants.push(r);
    });
    return groups;
  }

  /* ---------------- INIT ---------------- */

  function init() {
    var path = window.location.pathname;
    if (path.includes("/checkouts") || path.includes("/thank_you")) return;
    // Runs on the registration page whatever its handle (registration / registrant / …)
    if (!/\/pages\/[^\/]*registr/i.test(path)) return;

    ensureStyles();
    ensureContainer();

    if (getOrderReference()) {
      container().innerHTML =
        '<div id="cl-registration-page"><div class="reg-shell">' +
          '<div class="reg-spinner"></div>' +
          '<p style="text-align:center;color:#64748B;margin-top:-20px;">Loading your registration…</p>' +
        '</div></div>';
      loadOrderData().catch(function (err) {
        console.error(err);
        localStorage.removeItem(ORDER_STORAGE_KEY);
        if (err.apiError === "ORDER_ALREADY_FULFILLED") showFulfilledMessage(err.apiMessage);
        else showError("We could not locate this order. You may be getting this error due to registration being completed.");
      });
    } else {
      showOrderLookupUI();
    }
  }

  /* ---------------- ORDER IDENTIFICATION ---------------- */

  function getOrderReference() {
    const params = new URLSearchParams(window.location.search);
    const urlOrder = params.get("order");
    const urlEmail = params.get("email");

    if (urlOrder && urlEmail) {
      orderName = urlOrder.startsWith("#") ? urlOrder : "#" + urlOrder;
      orderEmail = urlEmail;
      saveOrderToStorage();
      return true;
    }

    if (!urlOrder && window.clCustomer && window.clCustomer.email && window.clCustomer.orderName) {
      orderName = window.clCustomer.orderName.startsWith("#") ? window.clCustomer.orderName : "#" + window.clCustomer.orderName;
      orderEmail = window.clCustomer.email;
      autoLoadedFromCustomer = true;
      saveOrderToStorage();
      return true;
    }

    const stored = localStorage.getItem(ORDER_STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (parsed.orderName && parsed.orderEmail) {
          orderName = parsed.orderName;
          orderEmail = parsed.orderEmail;
          return true;
        }
      } catch (e) { console.error("Failed to parse stored order reference:", e); }
    }
    return false;
  }

  function saveOrderToStorage() {
    localStorage.setItem(ORDER_STORAGE_KEY, JSON.stringify({ orderName: orderName, orderEmail: orderEmail }));
  }

  /* ---------------- ORDER LOOKUP UI ---------------- */

  function showOrderLookupUI() {
    container().innerHTML =
      '<div id="cl-registration-page"><div class="reg-shell">' +
        '<div class="reg-intro">' +
          '<span class="reg-eyebrow">' + ICON.receipt + ' Find your order</span>' +
          '<h1>Confirm Your<br>Registrants</h1>' +
          '<p class="sub">Enter your order number and email to get started.</p>' +
        '</div>' +
        '<div class="reg-lookup">' +
          '<h2>Find your order</h2>' +
          '<p>We\u2019ll pull up the seats on your order so you can assign them.</p>' +
          '<div class="reg-field"><label>Order number</label><input id="lookup-order" type="text" placeholder="#1001"></div>' +
          '<div class="reg-field"><label>Email address</label><input id="lookup-email" type="email" placeholder="you@example.com"></div>' +
          '<button id="lookup-submit" class="btn-continue">Continue ' + ICON.arrow + '</button>' +
          '<p id="lookup-error" class="modal-error" style="margin:14px 0 0;"></p>' +
        '</div>' +
      '</div></div>';
    document.getElementById("lookup-submit").onclick = handleOrderLookup;
  }

  function handleOrderLookup() {
    const orderInput = document.getElementById("lookup-order").value.trim();
    const emailInput = document.getElementById("lookup-email").value.trim();
    const errorEl = document.getElementById("lookup-error");

    if (!orderInput || !emailInput) { errorEl.textContent = "Please enter both order number and email."; errorEl.style.display = "block"; return; }
    if (!emailInput.includes("@")) { errorEl.textContent = "Please enter a valid email address."; errorEl.style.display = "block"; return; }

    orderName = orderInput.startsWith("#") ? orderInput : "#" + orderInput;
    orderEmail = emailInput;
    saveOrderToStorage();
    loadOrderData();
  }

  async function fetchOrderFromShopify() {
    const params = new URLSearchParams({ order: orderName.replace("#", ""), email: orderEmail });
    const res = await fetch(LOOKUP_URL + "?" + params.toString());
    const data = await res.json();
    if (!data || !data.ok) {
      const err = new Error((data && data.error) || "Order lookup failed");
      err.apiError = (data && data.error) || null;
      err.apiMessage = (data && data.message) || null;
      throw err;
    }
    return data;
  }

  /* ---------------- LOAD ORDER DATA ---------------- */

  async function loadOrderData() {
    const order = await fetchOrderFromShopify();
    if (order.registration_status && order.registration_status.includes("complete")) {
      showLockedCompletionScreen(order.registration_payload);
      return;
    }

    orderNumericId = order.order_id;
    orderFinancialStatus = order.financial_status || null;
    lineItems = order.line_items || [];

    seatMap = [];
    let seatIndex = 0;
    for (const item of lineItems) {
      for (let i = 0; i < item.quantity; i++) {
        seatMap.push({
          seat_index: seatIndex,
          line_item_id: item.line_item_id,
          product_title: item.product_title,
          variant_title: item.variant_title || null,
          product_id: item.product_id || null,
          variant_id: item.variant_id || null,
          product_image: item.product_image || item.featured_image || item.image || null,
          product_handle: item.product_handle || item.handle || null,
          cart_registrant: (item.cart_registrants && item.cart_registrants[i]) || null
        });
        seatIndex++;
      }
    }
    totalQuantity = seatMap.length;
    if (totalQuantity === 0) { showError("Unable to determine registration seats for this order."); return; }
    loadExistingRegistration();
  }

  /* ---------------- LOAD EXISTING REGISTRATION ---------------- */

  function loadExistingRegistration() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        const draft = JSON.parse(stored);
        if (draft.orderName === orderName && draft.registrants && draft.registrants.length > 0) {
          registrants = draft.registrants;
          currentRegistrantIndex = registrants.length;
          if (currentRegistrantIndex >= totalQuantity && totalQuantity > 0) { showCompletedMessage(); return; }
          showRegistrationUI();
          return;
        }
      } catch (e) { console.error("Failed to parse stored registrants:", e); }
    }

    let hasCartData = false, allFromCart = true;
    registrants = [];
    for (let i = 0; i < seatMap.length; i++) {
      const seat = seatMap[i];
      if (seat.cart_registrant && seat.cart_registrant.progress === "complete") {
        registrants[i] = {
          firstName: seat.cart_registrant.first_name,
          lastName: seat.cart_registrant.last_name,
          email: seat.cart_registrant.email,
          line_item_id: seat.line_item_id,
          product_title: seat.product_title,
          variant_title: seat.variant_title,
          product_id: seat.product_id,
          variant_id: seat.variant_id
        };
        hasCartData = true;
      } else { allFromCart = false; }
    }

    if (hasCartData) {
      saveDraftToStorage();
      if (allFromCart) { showConfirmAllScreen(); return; }
      showRegistrationUI();
      return;
    }

    registrants = [];
    currentRegistrantIndex = 0;
    showRegistrationUI();
  }

  /* ---------------- REGISTRATION UI (review screen) ---------------- */

  function courseCard(group, isLast) {
    const isComplete = group.registeredCount === group.seats.length;
    const seatWord = group.seats.length === 1 ? "seat" : "seats";
    // Plain access description: session/format + seats purchased
    const access = (group.variant ? esc(group.variant) + " \u00b7 " : "") +
      group.seats.length + " " + seatWord + " purchased";
    return '' +
      '<div class="course-row' + (isLast ? " last" : "") + '">' +
        '<div class="course-row-main">' +
          '<h3>' + esc(group.title) + '</h3>' +
          '<p class="course-access">' + access + '</p>' +
        '</div>' +
        '<span class="course-count ' + (isComplete ? "done" : "") + '">' +
          (isComplete ? ICON.check : "") + group.registeredCount + " of " + group.seats.length + " confirmed</span>" +
      '</div>';
  }

  // No-backend-change fallback: if a course-media has a product handle but no
  // image, fetch the storefront product JSON and swap in its featured image.
  function hydrateCourseImages() {
    container().querySelectorAll('.course-media [data-course-handle]').forEach(function (el) {
      const handle = el.getAttribute('data-course-handle');
      if (!handle) return;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          const src = p && (p.featured_image || (p.images && p.images[0]));
          if (!src) return;
          const media = el.closest('.course-media');
          if (media) media.innerHTML = '<img class="cimg" src="' + src + '" alt="">';
        })
        .catch(function () {});
    });
  }

  function showRegistrationUI() {
    const courseGroups = {};
    seatMap.forEach(function (seat, idx) {
      const key = seat.variant_title ? seat.product_title + "|||" + seat.variant_title : seat.product_title;
      if (!courseGroups[key]) courseGroups[key] = { title: seat.product_title, variant: seat.variant_title, image: seat.product_image || null, handle: seat.product_handle || null, seats: [], registeredCount: 0 };
      courseGroups[key].seats.push(idx);
      if (registrants[idx]) courseGroups[key].registeredCount++;
    });

    const confirmedCount = registrants.filter(function (r) { return r; }).length;
    const pct = totalQuantity ? Math.round((confirmedCount / totalQuantity) * 100) : 0;
    const left = totalQuantity - confirmedCount;

    const courseKeys = Object.keys(courseGroups);
    let courseHTML = "";
    courseKeys.forEach(function (k, idx) { courseHTML += courseCard(courseGroups[k], idx === courseKeys.length - 1); });

    // One inline form block per seat — all on this page, no click-through.
    const multiCourse = courseKeys.length > 1;
    let seatsHTML = "";
    seatMap.forEach(function (seat, i) {
      const r = registrants[i] || { firstName: "", lastName: "", email: "" };
      const courseLine = esc(seat.product_title) + (seat.variant_title ? ' \u00b7 ' + esc(seat.variant_title) : '');
      seatsHTML +=
        '<div class="seat-form" data-seat="' + i + '">' +
          '<div class="seat-head">' +
            '<span class="seat-num">Registrant ' + (i + 1) + '</span>' +
            '<span class="seat-course">' + courseLine + '</span>' +
          '</div>' +
          '<div class="field-2">' +
            '<div class="field"><label>First name</label><input id="reg-fname-' + i + '" type="text" value="' + esc(r.firstName) + '"></div>' +
            '<div class="field"><label>Last name</label><input id="reg-lname-' + i + '" type="text" value="' + esc(r.lastName) + '"></div>' +
          '</div>' +
          '<div class="field-2">' +
            '<div class="field"><label>Email</label><input id="reg-email-' + i + '" type="email" value="' + esc(r.email) + '"></div>' +
            '<div class="field"><label>Confirm email</label><input id="reg-cemail-' + i + '" type="email" value="' + esc(r.email) + '"></div>' +
          '</div>' +
          '<p class="seat-error" id="seat-error-' + i + '"></p>' +
        '</div>';
    });

    const hint = left > 0
      ? '<b>' + left + ' registrant' + (left === 1 ? "" : "s") + ' still needed</b> before access is sent to everyone.'
      : 'All set — everyone will receive their course access email.';

    container().innerHTML =
      '<div id="cl-registration-page"><main class="reg-shell">' +
        '<div class="reg-intro">' +
          '<span class="reg-eyebrow">' + ICON.check + ' Almost done</span>' +
          '<h1>Confirm Your<br>Registrants</h1>' +
          '<p class="sub">Enter a name and email for each seat. Everyone gets their own login and their own course access.</p>' +
          '<div class="order-tag">' + ICON.receipt + ' Order <b>' + esc(orderName) + '</b> \u00b7 ' + confirmedCount + ' of ' + totalQuantity + ' confirmed</div>' +
          (autoLoadedFromCustomer ? '<div style="margin-top:8px;"><a href="#" id="different-order-link" style="font-size:13px;color:#64748B;text-decoration:underline;">Register a different order</a></div>' : '') +
        '</div>' +
        '<div class="seat-list">' + seatsHTML + '</div>' +
        '<div class="reg-continue">' +
          '<button id="complete-registration" class="btn-continue">Complete Registration ' + ICON.arrow + '</button>' +
          '<button id="save-exit" class="btn-saveexit">Save &amp; finish later</button>' +
          '<p class="reg-hint">' + hint + '</p>' +
        '</div>' +
        '<p class="reg-foot">Questions about your order? <a href="mailto:support@careerlearning.com">Contact support</a></p>' +
      '</main></div>';

    document.getElementById("complete-registration").onclick = handleCompleteAll;
    document.getElementById("save-exit").onclick = handleSaveExitAll;

    const diffLink = document.getElementById("different-order-link");
    if (diffLink) diffLink.onclick = function (e) {
      e.preventDefault();
      autoLoadedFromCustomer = false; orderName = null; orderEmail = null;
      localStorage.removeItem(ORDER_STORAGE_KEY);
      showOrderLookupUI();
    };

    hydrateCourseImages();
  }

  function readSeat(i) {
    const f = document.getElementById("reg-fname-" + i);
    if (!f) return null;
    return {
      firstName: f.value.trim(),
      lastName: (document.getElementById("reg-lname-" + i).value || "").trim(),
      email: (document.getElementById("reg-email-" + i).value || "").trim(),
      cemail: (document.getElementById("reg-cemail-" + i).value || "").trim()
    };
  }
  function seatErr(i, msg) {
    const el = document.getElementById("seat-error-" + i);
    if (el) { el.textContent = msg || ""; el.style.display = msg ? "block" : "none"; }
  }
  function commitSeat(i, vals) {
    const seat = seatMap[i];
    registrants[i] = {
      firstName: vals.firstName, lastName: vals.lastName, email: vals.email,
      line_item_id: seat.line_item_id, product_title: seat.product_title,
      variant_title: seat.variant_title, product_id: seat.product_id, variant_id: seat.variant_id
    };
  }

  async function handleCompleteAll() {
    let firstBad = -1;
    for (let i = 0; i < totalQuantity; i++) {
      const v = readSeat(i); seatErr(i, "");
      if (!v.firstName || !v.lastName || !v.email || !v.cemail) { seatErr(i, "Please complete all fields."); if (firstBad < 0) firstBad = i; continue; }
      if (v.email !== v.cemail) { seatErr(i, "Email addresses do not match."); if (firstBad < 0) firstBad = i; continue; }
      if (v.email.indexOf("@") === -1) { seatErr(i, "Please enter a valid email address."); if (firstBad < 0) firstBad = i; continue; }
    }
    if (firstBad < 0) {
      for (let i = 0; i < totalQuantity; i++) {
        const v = readSeat(i);
        for (let j = 0; j < i; j++) {
          const w = readSeat(j);
          if (seatMap[i].line_item_id === seatMap[j].line_item_id && v.email.toLowerCase() === w.email.toLowerCase()) {
            seatErr(i, "This email is already used for another seat in this course."); if (firstBad < 0) firstBad = i; break;
          }
        }
      }
    }
    if (firstBad >= 0) {
      const node = container().querySelector('[data-seat="' + firstBad + '"]');
      if (node) node.scrollIntoView({ behavior: "smooth", block: "left" });
      return;
    }
    for (let i = 0; i < totalQuantity; i++) commitSeat(i, readSeat(i));
    saveDraftToStorage();

    const btn = document.getElementById("complete-registration");
    if (btn) { btn.disabled = true; btn.innerHTML = "Submitting\u2026"; }
    const result = await saveToOrderMetafields();
    if (result.success && result.status === "complete") {
      if (typeof fm !== "undefined") fm.trackCustomEvent("Registration Completed", { email: orderEmail, order: orderName });
      showCompletedMessage();
    } else {
      if (btn) { btn.disabled = false; btn.innerHTML = "Complete Registration " + ICON.arrow; }
      const hint = container().querySelector(".reg-hint");
      if (hint) { hint.innerHTML = "There was an issue submitting. Please try again."; hint.style.color = "#dc2626"; }
    }
  }

  async function handleSaveExitAll() {
    let any = false;
    for (let i = 0; i < totalQuantity; i++) {
      const v = readSeat(i); seatErr(i, "");
      if (v.firstName || v.lastName || v.email) {
        if (v.email && v.cemail && v.email !== v.cemail) { seatErr(i, "Email addresses do not match."); continue; }
        commitSeat(i, v); any = true;
      }
    }
    saveDraftToStorage();
    if (any) await saveToOrderMetafields();
    showSavedMessage();
  }

  /* ---------------- CONFIRM ALL FROM CART ---------------- */

  function summaryGroupsHTML(groups, useUnderscore) {
    let html = "";
    Object.values(groups).forEach(function (group) {
      html += '<div style="margin-bottom:18px;">' +
        '<p class="panel-label" style="border-bottom:2px solid #1F60AE;padding-bottom:8px;">' + esc(group.title) +
        (group.variant ? ' <span style="font-weight:600;text-transform:none;letter-spacing:0;color:#64748B;">— ' + esc(group.variant) + '</span>' : '') + '</p>' +
        group.registrants.map(function (r) {
          const fn = useUnderscore ? r.first_name : r.firstName;
          const ln = useUnderscore ? r.last_name : r.lastName;
          return '<div class="reg-card"><div class="avatar">' + esc(initials(fn, ln)) + '</div>' +
            '<div class="info"><div class="nm">' + esc(fn) + ' ' + esc(ln) + ' <span class="tick">' + ICON.check + '</span></div>' +
            '<div class="em">' + esc(r.email) + '</div></div></div>';
        }).join("") +
        '</div>';
    });
    return html;
  }

  function showConfirmAllScreen() {
    const groups = groupBySeat(registrants, function (r, i) { return seatMap[i]; });
    container().innerHTML =
      '<div id="cl-registration-page"><div class="reg-shell">' +
        '<div class="reg-intro">' +
          '<span class="reg-eyebrow">' + ICON.check + ' Quick review</span>' +
          '<h1>Confirm Your<br>Registrants</h1>' +
          '<p class="sub">These registrants were entered during checkout. Review and confirm to send access.</p>' +
          '<div class="order-tag">' + ICON.receipt + ' Order <b>' + esc(orderName) + '</b></div>' +
        '</div>' +
        '<div class="panel"><p class="panel-label">Registrants from checkout</p>' + summaryGroupsHTML(groups, false) + '</div>' +
        '<div class="reg-continue" style="display:flex;gap:10px;">' +
          '<button id="edit-registrants" class="btn-continue" style="flex:1;background:#fff;color:#123A6F;border-color:#E0E0E0;box-shadow:none;">Edit</button>' +
          '<button id="confirm-all" class="btn-continue" style="flex:2;">Confirm All Registrants ' + ICON.arrow + '</button>' +
        '</div>' +
        '<p id="confirm-status" class="reg-hint" style="display:none;"></p>' +
      '</div></div>';

    document.getElementById("confirm-all").onclick = async function () {
      const btn = document.getElementById("confirm-all");
      const statusEl = document.getElementById("confirm-status");
      btn.disabled = true; btn.textContent = "Submitting…"; btn.style.opacity = "0.6";
      const result = await saveToOrderMetafields();
      if (result.success && result.status === "complete") {
        if (typeof fm !== "undefined") fm.trackCustomEvent("Registration Completed", { email: orderEmail, order: orderName });
        showCompletedMessage();
      } else {
        statusEl.textContent = "There was an issue. Please try again."; statusEl.style.color = "#dc2626"; statusEl.style.display = "block";
        btn.disabled = false; btn.innerHTML = "Confirm All Registrants " + ICON.arrow; btn.style.opacity = "1";
      }
    };
    document.getElementById("edit-registrants").onclick = function () { currentRegistrantIndex = 0; showRegistrationUI(); };
  }

  /* ---------------- MODAL ---------------- */

  function showRegistrantModal() {
    removeModal();
    const seat = seatMap[currentRegistrantIndex];
    const existing = registrants[currentRegistrantIndex] || { firstName: "", lastName: "", email: "" };
    const isLast = currentRegistrantIndex === totalQuantity - 1;

    let dots = "";
    for (let i = 0; i < totalQuantity; i++) {
      let cls = "d";
      if (i === currentRegistrantIndex) cls += " active";
      else if (registrants[i]) cls += " filled";
      dots += '<span class="' + cls + '"></span>';
    }

    let actions = '<button class="btn-ghost" id="reg-cancel">Save & Exit</button>';
    if (currentRegistrantIndex > 0) actions += '<button class="btn-ghost" id="reg-back">Back</button>';
    if (!isLast) actions += '<button class="btn-ghost" id="reg-skip">Skip</button>';
    actions += '<button class="btn-primary-modal" id="reg-next">' + (isLast ? "Complete Registration" : "Save & Next") + '</button>';

    container().innerHTML =
      '<div id="cl-registration-page"><main class="reg-shell">' +
        '<div class="reg-intro">' +
          '<span class="reg-eyebrow"><span class="modal-dots" style="display:inline-flex">' + dots + '</span> Registrant ' + (currentRegistrantIndex + 1) + ' of ' + totalQuantity + '</span>' +
          '<h1>Add registrant</h1>' +
          '<p class="sub">Enrolling in <strong style="color:var(--cl-primary);font-weight:700;">' + esc(seat.product_title) + '</strong>' + (seat.variant_title ? ' \u00b7 ' + esc(seat.variant_title) : '') + '</p>' +
        '</div>' +
        '<div class="entry">' +
          '<div class="field-2">' +
            '<div class="field"><label>First name</label><input id="reg-fname" type="text" value="' + esc(existing.firstName) + '"></div>' +
            '<div class="field"><label>Last name</label><input id="reg-lname" type="text" value="' + esc(existing.lastName) + '"></div>' +
          '</div>' +
          '<div class="field"><label>Email</label><input id="reg-email" type="email" value="' + esc(existing.email) + '"></div>' +
          '<div class="field"><label>Confirm email</label><input id="reg-cemail" type="email" value="' + esc(existing.email) + '"></div>' +
          '<p id="modal-error" class="modal-error" style="margin:2px 0 0;"></p>' +
          '<div class="entry-actions">' + actions + '</div>' +
        '</div>' +
      '</main></div>';
    bindModalEvents();
  }

  function removeModal() {
    const modal = document.getElementById("registrant-modal");
    if (modal) modal.remove();
  }

  function bindModalEvents() {
    document.getElementById("reg-cancel").onclick = async function () {
      const fname = document.getElementById("reg-fname").value.trim();
      const lname = document.getElementById("reg-lname").value.trim();
      const email = document.getElementById("reg-email").value.trim();
      if (fname || lname || email) {
        const seat = seatMap[currentRegistrantIndex];
        registrants[currentRegistrantIndex] = {
          firstName: fname, lastName: lname, email: email,
          line_item_id: seat.line_item_id, product_title: seat.product_title,
          variant_title: seat.variant_title, product_id: seat.product_id, variant_id: seat.variant_id
        };
        saveDraftToStorage();
        await saveToOrderMetafields(); // exit point
      }
      removeModal();
      showRegistrationUI();
    };

    const back = document.getElementById("reg-back");
    if (back) back.onclick = function () { currentRegistrantIndex--; showRegistrantModal(); };

    const skip = document.getElementById("reg-skip");
    if (skip) skip.onclick = function () {
      for (let i = currentRegistrantIndex + 1; i < totalQuantity; i++) { if (!registrants[i]) { currentRegistrantIndex = i; showRegistrantModal(); return; } }
      currentRegistrantIndex++;
      showRegistrantModal();
    };

    document.getElementById("reg-next").onclick = handleSaveRegistrant;
  }

  /* ---------------- SAVE REGISTRANT ---------------- */

  async function handleSaveRegistrant() {
    const fname = document.getElementById("reg-fname").value.trim();
    const lname = document.getElementById("reg-lname").value.trim();
    const email = document.getElementById("reg-email").value.trim();
    const cemail = document.getElementById("reg-cemail").value.trim();
    const errorEl = document.getElementById("modal-error");

    if (!fname || !lname || !email || !cemail) { errorEl.textContent = "Please complete all fields."; errorEl.style.display = "block"; return; }
    if (email !== cemail) { errorEl.textContent = "Email addresses do not match."; errorEl.style.display = "block"; return; }
    if (!email.includes("@")) { errorEl.textContent = "Please enter a valid email address."; errorEl.style.display = "block"; return; }

    const seat = seatMap[currentRegistrantIndex];
    const isDuplicate = registrants.some(function (r, i) {
      return r && i !== currentRegistrantIndex && r.email.toLowerCase() === email.toLowerCase() && r.line_item_id === seat.line_item_id;
    });
    if (isDuplicate) { errorEl.textContent = "This email has already been used for another seat in this course."; errorEl.style.display = "block"; return; }

    registrants[currentRegistrantIndex] = {
      firstName: fname, lastName: lname, email: email,
      line_item_id: seat.line_item_id, product_title: seat.product_title,
      variant_title: seat.variant_title, product_id: seat.product_id, variant_id: seat.variant_id
    };
    saveDraftToStorage();

    let nextUnfilled = -1;
    for (let i = currentRegistrantIndex + 1; i < totalQuantity; i++) { if (!registrants[i]) { nextUnfilled = i; break; } }
    if (nextUnfilled !== -1) { currentRegistrantIndex = nextUnfilled; showRegistrantModal(); return; }

    const btn = document.getElementById("reg-next");
    if (btn) { btn.disabled = true; btn.textContent = "Submitting…"; }
    const result = await saveToOrderMetafields();
    const allFilled = registrants.filter(function (r) { return r; }).length === totalQuantity;
    removeModal();

    if (allFilled && result.status === "complete") {
      if (typeof fm !== "undefined") fm.trackCustomEvent("Registration Completed", { email: orderEmail, order: orderName });
      showCompletedMessage();
    } else {
      showRegistrationUI();
    }
  }

  /* ---------------- STORAGE ---------------- */

  function saveDraftToStorage() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      orderName: orderName, orderEmail: orderEmail, registrants: registrants, seatMap: seatMap, lastUpdated: new Date().toISOString()
    }));
  }

  function getRegistrationStatus() {
    const filled = registrants.filter(function (r) { return r; }).length;
    if (filled === 0) return "pending";
    if (filled < totalQuantity) return "partial";
    return "complete";
  }

  /* ---------------- SEND TO N8N WEBHOOK ---------------- */

  async function saveToOrderMetafields() {
    const status = getRegistrationStatus();
    const payload = {
      order_name: orderName,
      order_email: orderEmail,
      total_seats: totalQuantity,
      registrants: registrants.filter(function (r) { return r; }).map(function (r, i) {
        const seatIndex = registrants.indexOf(r);
        const isNew = !submittedSeats.has(seatIndex);
        return {
          seat_index: i, first_name: r.firstName, last_name: r.lastName, email: r.email,
          line_item_id: r.line_item_id, product_title: r.product_title, variant_title: r.variant_title,
          product_id: r.product_id, variant_id: r.variant_id, progress: "complete", is_new: isNew
        };
      })
    };
    const webhookData = {
      order_id: orderNumericId, order_name: orderName, registration_status: status,
      financial_status: orderFinancialStatus, registration_payload: JSON.stringify(payload)
    };

    try {
      const response = await fetch(SAVE_URL, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(webhookData)
      });
      if (response.ok) {
        registrants.forEach(function (r, idx) { if (r) submittedSeats.add(idx); });
        return { success: true, status: status };
      }
      console.error("Request failed:", response.status);
      return { success: false, status: status };
    } catch (error) {
      console.error("Request error:", error);
      return { success: false, status: status };
    }
  }

  /* ---------------- COMPLETED / LOCKED / FULFILLED / ERROR ---------------- */

  function statusScreen(opts) {
    container().innerHTML =
      '<div id="cl-registration-page"><div class="reg-shell"><div class="reg-status">' +
        '<div class="badge-ic ' + (opts.error ? "err" : "ok") + '">' +
          (opts.error ? '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.4"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>' : ICON.check) +
        '</div>' +
        '<h3>' + esc(opts.title) + '</h3>' +
        (opts.order ? '<p style="color:#123A6F;font-weight:600;">Order: ' + esc(opts.order) + '</p>' : '') +
        '<p>' + opts.body + '</p>' +
        (opts.summary || '') +
        (opts.note ? '<p style="margin-top:12px;padding:12px 12px;background:#FFFBEB;border:1px solid #FBB834;border-radius:6px;font-size:13.5px;color:#735718;">' + opts.note + '</p>' : '') +
        (opts.button ? '<button class="btn-primary" id="status-btn" style="margin-top:12px;">' + esc(opts.button) + '</button>' : '') +
      '</div></div></div>';
    if (opts.onButton) { const b = document.getElementById("status-btn"); if (b) b.onclick = opts.onButton; }
  }

  function showCompletedMessage() {
    const groups = groupBySeat(registrants, function (r, i) { return seatMap[i]; });
    statusScreen({
      title: "Registration Complete",
      order: orderName,
      body: "All " + totalQuantity + " registrant(s) have been confirmed. <br> Please Note: <strong> A brief quality check may be required, each registrant will receive course access instructions by email within one business day.</strong>",
      summary: '<div style="text-align:left;margin-top:18px;">' + summaryGroupsHTML(groups, false) + '</div>',
      note: "<strong>Need to make changes?</strong><br>Contact <a href=\"mailto:support@careerlearning.com\" style=\"color:#1F60AE;\">support@careerlearning.com</a>"
    });
    localStorage.removeItem(STORAGE_KEY);
  }

  function showSavedMessage() {
    const done = registrants.filter(function (r) { return r; }).length;
    statusScreen({
      title: "Progress Saved",
      order: orderName,
      body: done + " of " + totalQuantity + " registrant(s) saved. Come back to this page anytime to finish — access is sent once everyone is confirmed.",
      button: "Keep editing",
      onButton: function () { showRegistrationUI(); }
    });
  }

  function showLockedCompletionScreen(payloadJSON) {
    let payload;
    try { payload = typeof payloadJSON === "string" ? JSON.parse(payloadJSON) : payloadJSON; } catch (e) { payload = null; }
    let summary = "";
    if (payload && payload.registrants) {
      const groups = {};
      payload.registrants.forEach(function (r) {
        const key = r.variant_title ? r.product_title + "|||" + r.variant_title : r.product_title;
        if (!groups[key]) groups[key] = { title: r.product_title, variant: r.variant_title, registrants: [] };
        groups[key].registrants.push(r);
      });
      summary = '<div style="text-align:left;margin-top:22px;">' + summaryGroupsHTML(groups, true) + '</div>';
    }
    statusScreen({
      title: "Registration Complete",
      order: orderName,
      body: "This order has already been registered and is locked. All registrants have been confirmed and will receive their course access.",
      summary: summary,
      note: "<strong>For PO Orders:</strong> registrants receive course access once the approved PO has been received.<br><br><strong>Need to make changes?</strong> Contact <a href=\"mailto:support@careerlearning.com\" style=\"color:#1F60AE;\">support@careerlearning.com</a>"
    });
    localStorage.removeItem(STORAGE_KEY);
  }

  function showFulfilledMessage(message) {
    statusScreen({
      title: "Order Already Processed",
      body: esc(message || "This order has already been fulfilled."),
      note: "<strong>Need to make changes?</strong><br>Contact <a href=\"mailto:support@careerlearning.com\" style=\"color:#1F60AE;\">support@careerlearning.com</a>",
      button: "Try Different Order",
      onButton: function () { localStorage.removeItem(ORDER_STORAGE_KEY); location.reload(); }
    });
  }

  function showError(message) {
    statusScreen({
      error: true,
      title: "Registration Error",
      body: esc(message),
      note: "Please contact support if this issue persists.",
      button: "Try Different Order",
      onButton: function () { localStorage.removeItem(ORDER_STORAGE_KEY); location.reload(); }
    });
  }
})();